/* Lightweight landing helpers without Firebase (keeps home.html fast for logged-out visitors). */

import { fillIcons } from "./fill-icons.js?v=20261007m";
import { initSprinkleRain } from "./sprinkle-rain.js?v=20261007m";
import { initButtonSprinkle } from "./button-sprinkle.js?v=20261007m";
import { copyrightNotice, ensureCopyrightFooter } from "./site-footer.js?v=20261007m";

export { fillIcons, copyrightNotice, ensureCopyrightFooter };

export function initShellEffects() {
  if (!document.getElementById("sprinkle-rain")) {
    const rain = document.createElement("div");
    rain.id = "sprinkle-rain";
    rain.className = "sprinkle-rain";
    rain.setAttribute("aria-hidden", "true");
    document.body.prepend(rain);
  }
  initSprinkleRain();
  initButtonSprinkle();
  const v = window.__CCJ_V || "dev";
  import(`./media-save-guard.js?v=${v}`)
    .then((mod) => mod.wireMediaSaveGuard?.())
    .catch(() => {});
  import(`./analytics.js?v=${v}`)
    .then((mod) => mod.bootAnalytics())
    .catch(() => {});
}
